<template>
    <div class="pop">
        <van-popup v-model="show" position="center" @click-overlay="close">
            <div class="content">
                <div class="top_content">
                    <div class="left_box">
                        <img :src="info.imageUrl" alt="">
                    </div>
                    <div class="right_box">
                        <div class="title">
                            {{ info.gameName }}
                        </div>
                        <div class="platform">
                            {{ info.gameCategoryType }}
                        </div>
                        <!-- <div class="rank">
                            RTP:{{ info.rtp }}%
                        </div> -->
                    </div>
                </div>
                <div class="play_btn" @click.stop="onShowGamePopup(info)">
                    {{ $t("lang.Play") }}
                    <i class="iconfont icon-shipin"></i>
                </div>
                <div class="fav_icon" @click.stop="addCollect(info)">
                    <i v-if="activeIds.includes(info.id)" class="iconfont icon-a-shoucangyishoucang"></i>
                    <i v-else class="iconfont icon-a-shoucang_quxiaoshoucang"></i>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
import { Toast } from 'vant'
import {
    addFav,
    removeFav
} from '@/api/game'
export default {
    props: {
        showPop: {
            type: Boolean,
            default: false
        },
        info: {
            type: Object,
            default: () => ({})
        },
        activeIds: {
            type: Array,
            default: () => { return [] }
        }
    },
    computed: {
        isLogin() {
            return !!this.$store.getters.token
        }
    },
    watch: {
        showPop(newVal) {
            this.show = newVal
        }
    },
    data() {
        return {
            show: this.showPop,
            isDebounced: false
        }
    },
    mounted() { },
    methods: {
        close() {
            this.$emit('close')
        },
        async addCollect(item) {
            if (!this.isDebounced) {
                this.isDebounced = true
                const that = this
                if (that.activeIds.includes(item.id)) {
                    const index = that.activeIds.indexOf(item.id)
                    if (index !== -1) {
                        await removeFav({
                            id: item.id
                        })
                            .then((res) => {
                                if (res.code === 0) {
                                    that.$emit('activeIdsSplice', index)
                                    Toast(that.$t('home.CollectionCanceled'))
                                }
                            })
                    }
                } else {
                    await addFav({
                        id: item.id
                    })
                        .then((res) => {
                            if (res.code === 0) {
                                that.$emit('activeIdsPush', item.id)
                                Toast(that.$t('home.CollectionSucc'))
                            }
                        })
                }
                setTimeout(() => {
                    this.isDebounced = false
                }, 500)
            } else {
                console.log('111')
            }
        },
        onShowGamePopup(info) {
            this.$emit('onShowGamePopup', info)
        }
    }
}
</script>

<style scoped lang="scss">
@import '@/common/styles/viriables.scss';

.pop {
    text-align: left;

    ::v-deep .van-popup {
        background: transparent;
        width: 94%;
        max-width: 410px;
    }

    .content {
        width: 100%;
        height: 100%;
        border-radius: .28rem;
        box-sizing: border-box;
        position: relative;
        border: .01rem solid transparent;
        background-image:
            linear-gradient(to right, var(--theme-popup-box-bg), var(--theme-popup-box-bg)),
            linear-gradient(90deg, var(--theme-popup-box-border), var(--theme-popup-box-border));
        background-origin: border-box;
        background-clip: content-box, border-box;
        box-shadow: var(--theme-popup-box-shadow);
        .top_content {
            display: flex;
            flex-direction: column;
            align-items: center;
            column-gap: .3rem;
            margin-bottom: .3rem;
            width: 100%;
            padding-top: .6rem;

            .left_box {
                border-radius: .2rem;
                overflow: hidden;
                img {
                    width: 3.54rem;
                    height: 4.66rem;
                }
            }

            .right_box {
                width: 100%;
                text-align: center;
                padding-top: .28rem;

                .title {
                     color: var(--theme-bright-text);font-size: .34rem;
                    font-weight: bold;
                    max-width: 100%;
                    line-height: .4rem;
                }

                .platform {
                    font-size: .24rem;
                    color: #F6A4E3;
                    margin-top: .18rem;
                }

                .rank {
                    font-size: .24rem;
                    background: $bg-component-cyan-accent-gradient-color;
                    -webkit-background-clip: text;
                    background-clip: text;
                    color: transparent;
                }
            }
        }

        .play_btn {
            height: .88rem;
            width: 3.4rem;
            // line-height: .88rem;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            font-size: .36rem;
            color: var(--theme-gold-text);
            font-weight: bold;
            border-radius: 5rem;
            background: var(--theme-gold-bg);
            margin-bottom: .5rem;
            margin: .5rem auto;

            .icon-shipin {
                margin-left: .18rem;
                font-size: .46rem;
                // vertical-align: middle;
            }
        }

        .fav_icon {
            position: absolute;
            top: .25rem;
            right: .3rem;

            .iconfont {
                font-size: .48rem;

                &.icon-a-shoucang_quxiaoshoucang {
                     color: var(--theme-soft-text);}

                &.icon-a-shoucangyishoucang {
                    color: #FF0000;
                }
            }
        }
    }
}
</style>
